<!-- src/components/price_list.vue -->
<template src="./price_lists.html">

</template>

<script>

import { computed, ref } from 'vue'
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'
import { it } from 'date-fns/locale'

import '@vuepic/vue-datepicker/dist/main.css'
import '@/assets/css/main.css'

import Datepicker from '@vuepic/vue-datepicker'
import PriceListGrid from  '@/components/dashboard/price_list_grid.vue'

export default {
  name: "PriceLists",
  components: { 
    Datepicker,
    PriceListGrid,
  },
  data() {
    return {
      baseActions: [],
      bases: [],
      bracket_measure_units: [],
      calculation_formulas: [],
      copy_price_list: '',
      customers_list: [],
      currencies: [],
      dateFormat: 'dd-MM-yyyy',
      edit: false,
      equipment_sizes: [],
      goods_kinds: [],
      locations: [],
      measure_units: [],
      minimal_mount: null,
      new_price_list: '',
      names: [],
      packaging_kinds: [],
      prices_list: [],
      row: {
        active_voice: '',
        base_code: null,
        bracket_measure_unit: null,
        calculation_formula: null,
        currency: null,
        customer: null,
        end_date: '',
        equipment_size: '',
        location_code1: null,
        location_code2: null,
        lower_end_bracket: null,
        measure_unit: null,
        minimal_amount: null,
        packaging_kind: null,
        passive_voice: '',
        price_list_name: '',
        start_date: '',
        unit_amount: null,
        unit_cost: null,
        upper_end_bracket: null,
        voice_name: '',
        free_time: 0,
        max_peso_ingombro: 0,
      },
      rows_selected: [],
      search: {
        amount: null,
        cost: null,
        currency: null,
        customer: null,
        equipment_size: null,
        good_kind: null,
        location: null,
        package_kind: null,
        price_list_name: null,
        voice: null,
      },
      selectedAction: null,
      selectedBracketMeasureUnit: null,
      selectedCalculationFormula: null,
      selectedCustomer: null,
      selectedGoodsKind: null,
      selectedLocationId1: null,
      selectedLocationId2: null,
      selectedName: null, 
      selectedPackagingKind: null,
      selectedUM: null,
      showAlertMandatoryFormula: false,
      showAlertMandatoryMinimalAmount: false,
      showAlertMandatoryPricesList: false,
      showAlertMandatoryUnitAmount: false,
      showAlertMandatoryVoiceName: false,
      showClonePriceList: false,
      showCopyPriceList: false,                        
      showModal: false,
    }
  },
  computed: {
    selectedBase: {
      get() {
      
        return this.row.base?.id || ''
      },
      set(value) {
      
        if(!value) {         
          this.row.base = null
        } 
        else {        
        
          const base = this.bases.find(bas => bas.id === value)
          this.row.base = base || null
        }
      }
    },
    selectedCalculationFormula: {
      get() {
      
        return this.row.calculation_formula?.id || ''
      },
      set(value) {
      
        if(!value) {         
         
          this.row.calculation_formula = null
        } 
        else {        
        
          const calculation_formula = this.bases.find(formula => formula.id === value)
          this.row.calculation_formula = calculation_formula || null
        }
      }
    },
    selectedBracketMeasureUnit: {
      get() {
      
        return this.row.bracket_measure_unit?.id || ''
      },
      set(value) {
      
        if(!value) {         
          this.row.bracket_measure_unit = null
        } 
        else {        
        
          const bracket_measure_unit = this.bracket_measure_units.find(brack => brack.id === value)
          this.row.bracket_measure_unit = bracket_measure_unit || null
        }
      }
    },
    selectedCustomer: {
      get() {
      
        return this.row.customer?.id || ''
      },
      set(value) {
      
        if(!value) {         
          this.row.customer = null
        } 
        else {        
        
          const customer = this.customers_list.find(cust => cust.id === value)
          this.row.customer = customer || null
        }
      }
    },
    selectedCurrency: {
      get() {
      
        return this.row.currency?.id || ''
      },
      set(value) {
      
        if(!value) {         
          this.row.currency = null
        } 
        else {        
        
          const currency = this.currencies.find(curr => curr.id === value)
          this.row.currency = currency || null
        }
      }
    },
    selectedLocationId1: {
      get() {
      
        return this.row.location_code1?.id || ''
      },
      set(value) {

        if(!value) {
          
          this.row.location_code1 = null
        } 
        else {
        
          const location = this.locations.find(loc => loc.id === value)
          this.row.location_code1 = location || null
        }
      }
    },
    selectedLocationId2: {
      get() {
      
        return this.row.location_code2?.id
      },
      set(value) {
      
        if(!value) {
          
          this.row.location_code2 = null
        } 
        else {
        
          const location = this.locations.find(loc => loc.id === value)
          this.row.location_code2 = location || null
        }
      },
    },
    selectedUM: {
      get() {
     
        return this.row.measure_unit?.id
      },
      set(value) {
       
        if(!value) {
     
          this.row.measure_unit = null
        } 
        else {
        
          const measure_unit = this.measure_units.find(mu => mu.id === value)
          this.row.measure_unit = measure_unit || null
        }
      },
      selectedGoodsKind: {
        get() {
       
          return this.row.goods_kinds?.id
        },
        set(value) {
         
          if(!value) {
       
            this.row.goods_kinds = null
          } 
          else {
          
            const goods_kinds = this.goods_kinds.find(gk => gk.id === value)
            this.row.goods_kinds = goods_kinds || null
          }
        },
      },
      selectedPackagingKind: {
        get() {
       
          return this.row.packaging_kind?.id
        },
        set(value) {
         
          if(!value) {
       
            this.row.packaging_kind = null
          } 
          else {
          
            const packaging_kind = this.packaging_kind.find(pk => pk.id === value)
            this.row.packaging_kind = packaging_kind || null
          }
        },
      },      
    },
  },
  mounted() {

    const dateFormat = 'dd/MM/yyyy'
    const locale = 'it'
    this.loadBases()
    this.loadBracketMeasuresUnit()
    this.loadCalculationFormulas()
    this.loadCustomersList()
    this.loadCurrencies()
    this.loadGoodsKinds()
    this.loadEquipmentSizes()
    this.loadLocations()
    this.loadMeasureUnits()
    this.loadNames()
    this.loadPackagingKinds()
    this.loadPricesList()
    this.loadPricesListVoices()
  },
  methods: {
    cancelPriceList() {

      this.row = {
        active_voice: '',
        base_code: null,
        bracket_measure_unit: null,
        calculation_formula: null,
        currency: null,
        customer: null,
        end_date: '',
        equipment_size: '',
        location_code1: null,
        location_code2: null,
        lower_end_bracket: null,
        measure_unit: null,
        minimal_amount: null,
        passive_voice: '',
        price_list_name: '',
        start_date: '',
        unit_amount: null,
        unit_cost: null,
        upper_end_bracket: null,
        voice_name: '',
        free_time: 0,
        max_peso_ingombro: 0,
      }

      this.edit = false
    },
    clearInput() {

      this.row = {
        active_voice: '',
        base_code: null,
        bracket_measure_unit: null,
        calculation_formula: null,
        currency: null,
        customer: null,
        end_date: '',
        equipment_size: '',
        locale: it,
        location_code1: null,
        location_code2: null,
        lower_end_bracket: null,
        measure_unit: null,
        minimal_amount: null,
        packaging_kind: null,
        passive_voice: '',
        price_list_name: '',
        start_date: '',
        unit_amount: null,
        unit_cost: null,
        upper_end_bracket: null,
        voice_name: '',
        free_time: 0,
        max_peso_ingombro: 0,
      }
      this.selectedBase
      this.selectedBracketMeasureUnit = null
      this.selectedCalculationFormula = null
      this.selectedCustomer = null
      this.selectedGoodsKind = null
      this.selectedLocationId1 = null
      this.selectedLocationId2 = null
      this.selectedUM = null
      this.selectedPackagingKind = null
      this.cancelPriceList()
    },
    cloneSelectedRows() {

      this.showClonePriceList = true
    },
    copySelectedRows() {

      this.showCopyPriceList = true
    },
    async deleteRow() {

      if (!this.rows_selected || this.rows_selected.length === 0) {

        console.warn("No rows selected");
        return
      }
  
      try {

        for(const row of this.rows_selected) {

          const url = API_URL + "price_list/PriceListDetail/" + row + "/"
          const headers = {
            'User-ID': localStorage.getItem('User_id'),
            'token': localStorage.getItem('Token'),
          }
          const parameters = {
            deleted: true,
          }          
          await axios.patch(url, parameters, {headers})
          console.log(`Row ${row} marked as deleted`)
        }
      } 
      catch (error) {
      
        console.error("Error during delete operation:", error)
        return
      }
  
      if(!this.$refs.priceListGrid) {

        console.error("priceListGrid reference is missing")
        return
      }
  
      if(typeof this.$refs.priceListGrid.loadPricesList !== "function") {
        
        console.error("loadPricesList method is not defined on priceListGrid")
        return
      }
  
      this.$refs.priceListGrid.loadPricesList()
    },
    executeSelectedAction() {

      if(this.selectedAction == 1) {

        this.rows_selected.forEach(row => {

          this.deleteRow(row)
        })
      }
    },
    filterRows() {

      this.showModal = true
    },
    handleActions(rows) {

      this.rows_selected = rows
    },
    async handleRowSelected(id) {

      const url = API_URL + "price_list/PriceListDetail/"+id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }          
      const response = await axios.get(url, {headers: headers})
      this.row = response.data

      console.debug("ROW", JSON.stringify(this.row)) /**/

      if(this.row.bracket_measure_unit) {

        this.selectedBracketMeasureUnit = this.row.bracket_measure_unit.id
      }

      if(this.row.customer) {

        this.selectedCustomer = this.row.customer.id
      }
      else {

        this.selectedCustomer = 0
      }

      if(this.row.location_code1) {

        this.selectedLocationId1 = this.row.location_code1.id
      }
      else {

        this.selectedLocationId1 = 0
      }

      if(this.row.location_code2) {

        this.selectedLocationId2 = this.row.location_code2.id
      }
      else {

        this.selectedLocationId2 = 0
      }

      if(this.row.measure_unit) {
      
        this.selectedUM = Number(this.row.measure_unit)
      } 
      else {
      
        this.selectedUM = null // Set to null
      }

      if(this.row.calculation_formula) {
      
        this.selectedCalculationFormula = this.row.calculation_formula.id
      } 
      else {
      
        this.selectedCalculationFormula = null // Set to null
      }

      if(this.row.good_kind) {

        this.selectedGoodsKind = this.row.good_kind
      } 
      else {
      
        this.selectedGoodsKind = null // Set to null
      }

      if(this.row.packaging_kinds) {

        this.selectedPackagingKind = this.row.packaging_kinds
      } 
      else {
      
        this.selectedPackagingKind = null // Set to null
      }

      this.edit = true
    },
    hideModalClone() {

      this.showClonePriceList = false
      this.selectedAction = 0
    },
    handleSearch() {

      console.debug("*** handleSearch() this.search", this.search) /**/
      this.$refs.priceListGrid.loadPricesList(this.search)
    },
    async loadBases() {

      try {

        const url = API_URL+"price_list/BasesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.bases = response.data
      }
      catch(error) {

        console.debug("Error loading bases list:", error)
      }
    },
    async loadBracketMeasuresUnit() {

      try {

        const url = API_URL+"various/BracketMeasureUnitsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.bracket_measure_units = response.data
      }
      catch(error) {

        console.debug("Error loading measure units list:", error)
      }
    },
    async loadCalculationFormulas() {

      try {

        const url = API_URL+"price_list/CalculationFormulasList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.calculation_formulas = response.data
      }
      catch(error) {

        console.debug("Error loading calculation formulas list:", error)
      }
    },
    async loadCustomersList() {

      try {

        const url = API_URL+"customers/CustomersList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url,{headers: headers})
        this.customers_list = response.data
      }
      catch(error) {

        console.debug("Error loading customers list:", error)
      }
    },
    async loadCurrencies() {

      try {

        const url = API_URL+"price_list/CurrenciesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.currencies = response.data
      }
      catch(error) {

        console.debug("Error loading currencies list:", error)
      }
    },
    async loadEquipmentSizes() {

      try {

        const headers = {
          token: localStorage.getItem("Token"),
          "User-ID": localStorage.getItem("User_id"),
        }

        const url = API_URL+"various/EquipmentSizesList/"
        const response = await axios.get(url, {headers: headers})
        this.equipment_sizes = response.data
      }
      catch(error) {

        console.debug("Error loading equipment sizes list:", error)
      }      
    },
    async loadGoodsKinds() {

      try {

        const url = API_URL+"various/GoodsKindsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.goods_kinds = response.data
      }
      catch(error) {

        console.debug("Error loading currencies list:", error)
      }      
    },
    async loadLocations() {

      try {

        const url = API_URL+"geographic/LocationsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.locations = response.data
      }
      catch(error) {

        console.debug("Error loading locations list:", error)
      }
    },
    async loadMeasureUnits() {
      
      try {

        const url = API_URL + "various/MeasureUnitsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.measure_units = response.data
      } 
      catch (error) {
      
        console.debug("Error loading measure units list:", error)
      }
    },
    async loadNames() {

      try {

        const url = API_URL+"price_list/NamesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.names = response.data
      }
      catch(error) {

        console.debug("Error loading locations list:", error)
      }      
    },
    async loadPackagingKinds() {

      try {

        const url = API_URL+"various/PackagingsKindsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.packaging_kinds = response.data
      }
      catch(error) {

        console.debug("Error loading packaging kinds:", error)
      }      
    },
    async loadPricesList() {

      try {

        const url = API_URL + "price_list/PriceListDistinct/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.prices_list = response.data
      }
      catch(error) {

        console.debug("Error loading prices_list:", error)
      }      
    },
    async loadPricesListVoices() {

      try {

        const url = API_URL + "price_list/PriceListVoices/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.voices = response.data
      }
      catch(error) {

        console.debug("Error loading prices_list:", error)
      }      
    },
    rotateDate(dateString) {

      if(!dateString) {

        return null
      }

      const date = new Date(dateString)
 
      if(date) {
 
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        return year+"-"+month+"-"+day
      }
    
      return null
    },
    async savePriceList() {
      
      this.showAlertMandatoryVoiceName = false
      this.showAlertMandatoryMinimalAmount = false
      this.showAlertMandatoryPricesList = false
      this.showAlertMandatoryFormula = false

      if(
        this.row.unit_amount == null ||
        this.row.voice_name == '' ||
        this.row.price_list_name == '' ||
        this.selectedCalculationFormula == null
      ) {

        if(this.row.voice_name == '') {
          this.showAlertMandatoryVoiceName = true
        }

        if(this.row.unit_amount == null) {
          this.showAlertMandatoryUnitAmount = true
        }

        if(this.row.price_list_name == '') {
          this.showAlertMandatoryPricesList = true
        }

        if(this.selectedCalculationFormula == null) { // ← Fixed variable name
          this.showAlertMandatoryFormula = true
        }

        return
      }
      else {

        try {
          
          const url = API_URL + "price_list/PriceListDetail/"
          const data = {
            active_voice: this.row.active_voice || null,
            base: this.selectedBase || null,
            bracket_measure_unit: this.selectedBracketMeasureUnit || null,
            calculation_formula: this.selectedCalculationFormula || null,
            currency: this.selectedCurrency || null,
            customer: this.selectedCustomer || null,
            end_date: this.rotateDate(this.row.end_date) || null,
            equipment_size: this.row.equipment_size || '',
            location_code1: this.selectedLocationId1 || null,
            location_code2: this.selectedLocationId2 || null,
            lower_end_bracket: this.row.lower_end_bracket || null,
            measure_unit: this.selectedUM || null,
            minimal_amount: this.row.minimal_amount || null,
            packaging_kind: this.selectedPackagingKind || null,
            passive_voice: this.row.passive_voice || '',
            price_list_name: this.row.price_list_name || null,
            start_date: this.rotateDate(this.row.start_date) || null,
            unit_amount: this.row.unit_amount || null,
            unit_cost: this.row.unit_cost || null,
            upper_end_bracket: this.row.upper_end_bracket || null,
            voice_name: this.row.voice_name  || null,
            free_time: this.row.free_time || 0,
            max_peso_ingombro: this.row.max_peso_ingombro || 0,
          }

          const headers = {
            'User-ID': localStorage.getItem('User_id'),
            'token': localStorage.getItem('Token'),
          }
          const response = await axios.post(url, data, {headers})
          this.edit = false
          this.$refs.priceListGrid.reloadPricesList()
          this.clearInput()
          this.cancelPriceList()
        }
        catch (error) {
        
          console.error("Error updating price list:", error)
        }      
      }
    },
    updateActions() {

      this.$nextTick(() => {
    
        if(this.$refs.priceListGrid) {
          
          this.$refs.priceListGrid.loadPricesList(this.selectedName)
        }
      })
    },
    async updatePriceList() {

      try {

        console.debug("updatePriceList()", JSON.stringify(this.row))

        const url = API_URL + "price_list/PriceListDetail/"+this.row.id+"/"
        const data = {
          active_voice: this.row.active_voice || null,
          base_id: this.selectedBase || null,
          bracket_measure_unit_id: this.selectedBracketMeasureUnit || null,
          calculation_formula_id: this.selectedCalculationFormula || null,
          currency_id: this.row.currency?.id || null,
          customer_id: this.selectedCustomer || null,
          end_date: this.rotateDate(this.row.end_date),
          equipment_size: this.row.equipment_size || '',
          good_kind_id: this.selectedGoodsKind || null,
          location_code1_id: this.selectedLocationId1 || null,
          location_code2_id: this.selectedLocationId2 || null,
          lower_end_bracket: this.row.lower_end_bracket || null,
          measure_unit_id: this.selectedUM || null,
          minimal_amount: parseFloat(this.row.minimal_amount) || null,
          packaging_kinds_id: this.selectedPackagingKind || null,
          passive_voice: this.row.passive_voice || '',
          price_list_name: this.row.price_list_name,
          start_date: this.rotateDate(this.row.start_date),
          unit_amount: this.row.unit_amount || null,
          unit_cost: this.row.unit_cost || null,
          upper_end_bracket: this.row.upper_end_bracket || null,
          voice_name: this.row.voice_name,
          free_time: this.row.free_time,
          max_peso_ingombro: this.row.max_peso_ingombro,
        }

        console.debug("updatePriceList data", JSON.stringify(data))
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.patch(url, data, {headers})

        this.$refs.priceListGrid.reloadPricesList()
        this.edit = false
        this.clearInput()
        this.cancelPriceList()
      } 
      catch (error) {
      
        console.error("Error updating price list:", error)
      }
    },
  },
}

</script>

<style scoped>

.button {
  font-size: 0.7rem !important  
}

.filtered {
  background-color: #E1EBEE;
}

</style>





